(() => {
  'use strict';
  function initialize(scope = document) {
    scope.querySelectorAll('[data-booking-app]').forEach(app => {
      if (app.dataset.initialized) return;
      const data = JSON.parse(app.querySelector('[data-booking-data]').textContent);
      const strings = data.strings;
      const lang = document.documentElement.lang.startsWith('es') ? 'es' : 'fr';
      const money = cents => new Intl.NumberFormat(lang, {style:'currency',currency:document.body.dataset.currency || 'EUR'}).format(cents / 100);
      const form = app.querySelector('[data-booking-form]');
      const select = app.querySelector('[data-booking-select]');
      const quantity = app.querySelector('[data-booking-quantity-input]');
      const options = app.querySelector('[data-category-options]');
      const error = app.querySelector('[data-booking-error]');
      const submit = app.querySelector('[data-booking-submit]');
      let currentStep = 1;
      let confirmedPeople = false;
      let confirmedCategory = false;
      let busy = false;
      const text = (selector, value) => app.querySelectorAll(selector).forEach(n => { n.textContent = value; });
      const el = (tag, className, content) => {const node=document.createElement(tag);if(className)node.className=className;if(content!==undefined)node.textContent=content;return node;};
      const variant = () => data.variants.find(v => String(v.id) === select.value);
      const details = v => data.meta.variants[v.sku] || {fr:v.title,es:v.title,family:'standard',zone:'longside-upper',benefits_fr:[],benefits_es:[]};
      const title = v => details(v)[lang] || v.title;
      const showError = message => { error.textContent = message; error.hidden = false; };
      const clearError = () => {error.hidden=true;error.textContent='';};
      function validQuantity(requireAvailable = true) {
        const v=variant();
        if(requireAvailable && !v?.available){showError(strings.change_category);return false;}
        if(!quantity.checkValidity() || !Number.isSafeInteger(Number(quantity.value))){showError(strings.invalid_quantity);quantity.reportValidity();return false;}
        return true;
      }
      data.variants.forEach(v => {
        const label=el('label','category-option');
        const radio=el('input');radio.type='radio';radio.name='booking_category';radio.value=String(v.id);radio.disabled=!v.available;radio.checked=String(v.id)===select.value;
        const card=el('span');
        card.append(el('span','category-option-name',title(v)));
        const price=el('span','category-option-price',money(v.price));price.append(el('small','',v.available?strings.unit:strings.unavailable));card.append(price);label.append(radio,card);options.append(label);
        radio.addEventListener('change',()=>{
          if(!radio.checked)return;
          select.value=radio.value;confirmedCategory=false;applyVariant(true);setStep(2,false);
        });
      });
      function updateTotals() {
        const v=variant();if(!v)return;
        const info=details(v);const qty=Number(quantity.value);const valid=Number.isSafeInteger(qty)&&qty>=Number(quantity.min||1)&&(!quantity.max||qty<=Number(quantity.max));
        const matchesBreakdown=info.price_cents===v.price && Number.isInteger(info.base_cents) && info.base_cents+info.supplement_cents+info.fee_cents===v.price;
        text('[data-base-label]',matchesBreakdown && !info.fixed_price?strings.ticket:strings.ticket_price);
        text('[data-price-base]',money(matchesBreakdown?info.base_cents:v.price));
        text('[data-price-upgrade]',money(matchesBreakdown?info.supplement_cents:0));
        text('[data-price-fee]',money(matchesBreakdown?info.fee_cents:0));
        app.querySelector('[data-upgrade-row]').hidden=!matchesBreakdown || !info.supplement_cents;
        app.querySelector('[data-fee-row]').hidden=!matchesBreakdown || !info.fee_cents;
        text('[data-price-unit]',money(v.price));text('[data-price-total]',valid?money(v.price*qty):'—');
        text('[data-summary-quantity]',valid?qty:'—');text('[data-review-quantity]',valid?qty:'—');
        text('[data-summary-category]',title(v));text('[data-review-category]',title(v));
        submit.disabled=busy||!v.available||!valid;
      }
      function applyVariant(changed=false) {
        const v=variant();if(!v)return;
        const info=details(v);
        quantity.min=v.min||1;quantity.step=v.step||1;
        if(v.max)quantity.max=v.max;else quantity.removeAttribute('max');
        const min=Number(quantity.min),step=Number(quantity.step);
        let next=Math.max(min,Number(quantity.value)||min);
        next=min+Math.ceil((next-min)/step)*step;if(v.max)next=Math.min(next,v.max);quantity.value=next;
        text('[data-selected-title]',title(v));text('[data-selected-location]',info['location_'+lang]||'—');text('[data-selected-seats]',info['seats_'+lang]||'—');
        text('[data-selected-family]',info.family==='standard'?(lang==='es'?'Entradas estándar':'Billets standard'):(lang==='es'?'Hospitalidad':'Hospitalité'));
        const list=app.querySelector('[data-selected-benefits]');list.replaceChildren(...(info['benefits_'+lang]||[]).map(value=>el('li','',value)));
        text('[data-selected-note]',info['note_'+lang]||'');app.querySelector('[data-selected-note]').hidden=!info['note_'+lang];
        app.querySelector('[data-stadium-map]').dataset.zone=info.zone||'longside-upper';
        app.dispatchEvent(new CustomEvent('ticket:variant',{detail:{...info,title:title(v)}}));
        app.querySelectorAll('.category-option input').forEach(n=>{n.checked=n.value===select.value;});
        if(changed){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
        updateTotals();clearError();
      }
      function setStep(step, scroll=true) {
        currentStep=step;
        app.querySelectorAll('[data-step]').forEach(node=>{
          const number=Number(node.dataset.step);
          const complete=(number===1&&confirmedPeople&&step!==1)||(number===2&&confirmedCategory&&step!==2);
          node.classList.toggle('is-open',number===step);node.classList.toggle('is-complete',complete);
          node.querySelector('[data-edit-step]')?.toggleAttribute('hidden',!complete);
        });
        app.querySelectorAll('[data-progress]').forEach(node=>{const number=Number(node.dataset.progress);node.classList.toggle('is-current',number===step);node.classList.toggle('is-done',number<step);if(number===step)node.setAttribute('aria-current','step');else node.removeAttribute('aria-current');});
        app.querySelector('[data-summary-pending]').hidden=confirmedPeople;
        app.querySelector('[data-summary-pricing]').hidden=!confirmedPeople;
        text('[data-mobile-next]',step===3?strings.continue:strings.confirm);
        if(scroll){const target=app.querySelector(`[data-step="${step}"]`);target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});const heading=target.querySelector('h2');heading.tabIndex=-1;heading.focus({preventScroll:true});}
      }
      function confirm(step) {
        clearError();if(!validQuantity(step !== 1))return;
        if(step===1){confirmedPeople=true;setStep(2);}
        else if(step===2){confirmedCategory=true;setStep(3);}
        else form.requestSubmit();
      }
      app.querySelectorAll('[data-confirm-step]').forEach(button=>button.addEventListener('click',()=>confirm(Number(button.dataset.confirmStep))));
      app.querySelectorAll('[data-edit-step]').forEach(button=>button.addEventListener('click',()=>setStep(Number(button.dataset.editStep))));
      app.querySelectorAll('[data-booking-quantity]').forEach(button=>button.addEventListener('click',()=>{Number(button.dataset.bookingQuantity)>0?quantity.stepUp():quantity.stepDown();quantity.dispatchEvent(new Event('input',{bubbles:true}));}));
      quantity.addEventListener('input',()=>{confirmedCategory=false;updateTotals();});
      select.addEventListener('change',()=>{confirmedCategory=false;applyVariant(true);});
      app.querySelector('[data-mobile-next]').addEventListener('click',()=>confirm(currentStep));
      text('[data-event-restrictions]',data.meta['restrictions_'+lang]||'');
      form.addEventListener('submit',async event=>{
        if(!window.fetch)return;
        event.preventDefault();if(busy)return;
        if(window.P1BookingSession && !window.P1BookingSession.canProceed())return;
        clearError();if(!validQuantity())return;
        if(!confirmedPeople){confirm(1);return;}
        if(!confirmedCategory){confirm(2);return;}
        const payload=new FormData(form);payload.delete('booking_category');
        busy=true;window.P1BookingSession?.suspend();submit.disabled=true;text('[data-booking-submit]',strings.adding);app.querySelector('[data-mobile-next]').disabled=true;
        try {
          const base=(document.body.dataset.root||'/').replace(/\/$/,'');
          const response=await fetch(`${base}/cart/add.js`,{method:'POST',body:payload,credentials:'same-origin'});
          const result=await response.json();if(!response.ok)throw new Error(result.description||strings.connection_error);
          app.querySelector('[data-checkout-bridge]').requestSubmit();
        }catch(e){window.P1BookingSession?.resume();showError(e.message||strings.connection_error);busy=false;submit.disabled=false;app.querySelector('[data-mobile-next]').disabled=false;text('[data-booking-submit]',strings.continue);}
      });
      app.dataset.initialized='true';app.classList.add('booking-enhanced');
      applyVariant();setStep(1,false);
    });
  }
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
